import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgProgressModule } from 'ngx-progressbar';
import { ModalModule } from 'ngx-bootstrap/modal';

import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { ActionProgressComponent } from './action-progress/action-progress.component';
import { LoadingComponent } from './loading/loading.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';

@NgModule({
  declarations: [LoadingSpinnerComponent, ActionProgressComponent, LoadingComponent, ConfirmationModalComponent],
  imports: [CommonModule, NgProgressModule, ModalModule],
  exports: [LoadingSpinnerComponent, ActionProgressComponent, LoadingComponent, ConfirmationModalComponent],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: ModalModule.forRoot().providers,
    };
  }
}
